<mat-spinner
  *ngIf="(isLoading$ | async) === true && (hasError$ | async) === false"
  class="title-spinner"
  color="primary"
  diameter="30"
>
</mat-spinner>

<ng-container *ngIf="hasError$ | async">
  <div mat-dialog-content>
    <h3 class="warn-color">{{ "DIALOG.ERROR.WHILE_LOADING_STATEMENT" }}</h3>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>
      {{ "DIALOG.OK" | translate }}
    </button>
  </div>
</ng-container>

<ng-container
  *ngIf="(isLoading$ | async) === false && (hasError$ | async) === false"
>
  <div mat-dialog-content>
    <div [innerHtml]="statement"></div>
  </div>
  <div mat-dialog-actions>
    <div *ngIf="!data.isTakeOver; else takeOverActions">
      <button mat-button [mat-dialog-close]="'decline'" cdkFocusInitial>
        {{ "DIALOG.DECLINE" | translate }}
      </button>
      <button mat-button [mat-dialog-close]="1">
        {{ "DIALOG.ACCEPT" | translate }}
      </button>
    </div>
    <ng-template #takeOverActions>
      <div class="flex space-between merchant-type-container">
        <button
          mat-raised-button
          color="primary"
          [mat-dialog-close]="'MANUFACTURER'"
        >
          {{ "DIALOG.MANUFACTURER" | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [mat-dialog-close]="'IMPORTER'"
        >
          {{ "DIALOG.IMPORTER" | translate }}
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>
